import { SP_BIDDING_STRATEGIES, type SpBiddingStrategy } from '@/types/spCampaignCreate';

export function BiddingStrategyFields({
  value,
  onChange,
  disabled,
}: {
  value: SpBiddingStrategy;
  onChange: (value: SpBiddingStrategy) => void;
  disabled?: boolean;
}) {
  return (
    <fieldset className="border border-border rounded-xl p-4 space-y-3">
      <legend className="text-sm font-medium text-foreground-muted px-1">
        Campaign bidding strategy
      </legend>
      <div className="space-y-3">
        {SP_BIDDING_STRATEGIES.map((option) => (
          <label key={option.value} className="flex gap-3 cursor-pointer">
            <input
              type="radio"
              name="sp-bidding-strategy"
              className="mt-1"
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              disabled={disabled}
            />
            <span>
              <span className="block text-sm font-medium text-foreground">{option.label}</span>
              <span className="block text-xs text-foreground-muted mt-0.5">{option.description}</span>
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
